const REVISION_PATTERN = /^[0-9a-f]{40}$/;
const BUILD_ID_PATTERN = /^[A-Za-z0-9._:-]{1,128}$/;
const SOURCE_STATES = new Set(['clean', 'dirty', 'unknown']);

const valid = (value, pattern) => typeof value === 'string' && pattern.test(value.trim())
  ? value.trim()
  : null;

export const resolveFrontendRuntimeIdentity = (environment = process.env) => Object.freeze({
  revision: valid(environment.REACT_APP_SOURCE_REVISION, REVISION_PATTERN)?.toLowerCase() || null,
  buildId: valid(environment.REACT_APP_BUILD_ID, BUILD_ID_PATTERN),
  sourceState: SOURCE_STATES.has(environment.REACT_APP_SOURCE_STATE)
    ? environment.REACT_APP_SOURCE_STATE
    : 'unknown',
});

export const frontendRuntimeIdentity = resolveFrontendRuntimeIdentity();

export const frontendRuntimeIdentityHeaders = (identity = frontendRuntimeIdentity) => ({
  'X-All-Voiced-Frontend-Revision': identity.revision || 'unknown',
  'X-All-Voiced-Frontend-Build': identity.buildId || 'unknown',
  'X-All-Voiced-Frontend-Source-State': identity.sourceState,
});

export const publishFrontendRuntimeIdentity = (target = window) => {
  Object.defineProperty(target, '__ALL_VOICED_RUNTIME_IDENTITY__', {
    configurable: true,
    value: Object.freeze({ frontend: frontendRuntimeIdentity }),
    writable: false,
  });
};
